(function () {
    var banner = document.querySelector('[js-videoBanner-main-banner]');
    if (!banner) return;

    function playActiveVideo() {
        var isMobile = window.innerWidth < 750;
        var targetClass = isMobile
            ? '.js-banner-video-mobile'
            : '.js-banner-video-desktop';

        var activeVideo = banner.querySelector(targetClass);
        if (!activeVideo) return;
        var realSrc = activeVideo.getAttribute('data-src');
        if (realSrc && !activeVideo.src) {
            activeVideo.src = realSrc;
            activeVideo.load();
        }
        activeVideo.muted = true;
        activeVideo.defaultMuted = true;
        activeVideo.playsInline = true;
        var playPromise = activeVideo.play();
        if (playPromise) {
            playPromise.catch(function () {
                var playOnInteraction = function () {
                    activeVideo.play().catch(function () {});
                    window.removeEventListener('touchstart', playOnInteraction);
                    window.removeEventListener('click', playOnInteraction);
                };
                window.addEventListener('touchstart', playOnInteraction, {
                    once: true,
                    passive: true
                });
                window.addEventListener('click', playOnInteraction, {
                    once: true
                });
            });
        }
    }

    function deferredPlay() {
        if ('requestIdleCallback' in window) {
            requestIdleCallback(playActiveVideo, {
                timeout: 1000
            });
        } else { 
            setTimeout(playActiveVideo, 500);  
        }
    }

    if (document.readyState === 'complete') {
        deferredPlay();
    } else {
        window.addEventListener('load', deferredPlay, {
            once: true
        });
    }

    function initSlider(slider, options) {
        if (!slider || slider.swiper) return;
        new Swiper(slider, options);
    }

    var bottomSlider = document.querySelector(
        '.bottom_products_slider.swiper-container'
    );

    var bestsellerSlider = document.querySelector(
        '.bestseller_products_slider.swiper-container'
    );

    function initBottomSlider() {
        initSlider(bottomSlider, {
            freeMode: true,
            slidesPerView: 2.1,
            spaceBetween: 3,
            navigation: {
                nextEl: bottomSlider.querySelector('.swiper-button-next'),
                prevEl: bottomSlider.querySelector('.swiper-button-prev')
            },
            breakpoints: {
                1025: {
                    slidesPerView: 2.5,
                    spaceBetween: 3
                },
                768: {
                    slidesPerView: 2.1,
                    spaceBetween: 2
                },
                320: {
                    slidesPerView: 2.22,
                    spaceBetween: 2
                }
            }
        });
    }

    function initBestsellerSlider() {
        initSlider(bestsellerSlider, {
            freeMode: true,
            slidesPerView: 4,
            loop: false,
            spaceBetween: 3,
            navigation: {
                nextEl: bestsellerSlider.querySelector('.swiper-button-next'),
                prevEl: bestsellerSlider.querySelector('.swiper-button-prev')
            },
            breakpoints: {
                1025: {
                    slidesPerView: 4,
                    spaceBetween: 3
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 3
                },
                320: {
                    slidesPerView: 1.7,
                    spaceBetween: 3
                }
            }
        });
    }

    if ('IntersectionObserver' in window) {
        var sliderObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                var slider = entry.target;
                if (slider === bottomSlider) {
                    initBottomSlider();
                }
                if (slider === bestsellerSlider) {
                    initBestsellerSlider();
                }
                observer.unobserve(slider); 
            });
        }, {
            root: null,
            rootMargin: '300px 0px',
            threshold: 0
        });
        if (bottomSlider) {
            sliderObserver.observe(bottomSlider);
        }
        if (bestsellerSlider) {
            sliderObserver.observe(bestsellerSlider);
        }
    } else {
        if (bottomSlider) {
            initBottomSlider();
        }
        if (bestsellerSlider) {
            initBestsellerSlider();
        }
    }
})();